import React from 'react';

type PaginationInfoProps = {
  pageSize: number;
  pageIndex: number;
  totalCount: number;
};

export const PaginationInfo = ({
  pageSize,
  pageIndex,
  totalCount,
}: PaginationInfoProps) => {
  const pageCount = Math.ceil(totalCount / pageSize);
  const startIndex = pageIndex * pageSize;
  const endIndex =
    pageIndex < pageCount - 1 ? startIndex + pageSize : totalCount;

  return (
    <span className="text-gray-400">{`${
      totalCount === 0 ? 0 : startIndex + 1
    }-${endIndex} of ${totalCount}`}</span>
  );
};
